// import {documentTool,fontInfo,tableInfo } from './const'
export default {
    state: {
        btnType: -1, // number 布局方式
        previousLayout: -1, // 之前的布局
        applyOption: "Selected", // 修改对象 string
        showPhoto: false, // 显示头像 boolean
        hasPhotoShowInMul: false, // 多选中有用户头像显示
        hasPhotoHideInMul: false, // 多选中有用户头像隐藏
        mulSelect: false, // 多选
        photoDirect: "-1", // 头像方向 string
        keepShapeSize: false, // boolean
        textVertical: false, // boolean
        textWrap: false, // 文本是否换行
        canAddColleague: false, // boolean
        width: 0, // number
        height: 0, // number
        vertical: 0, // number
        horizontal: 0, // number
        orgVerDistance: 5, //number 结组织构图垂直间距
        orgHorDistance: 5, //number 结组织构图水平间距
        itemList: [], // Array: [object]
        tableList: [], // Array: [object]
        leftData: [], // Array: [object]
        rightData: [], // Array: [object]
        double: false, // boolean 控制是否两列 [所有行或者除了最后一行都为双列]
        autoSize: false, // boolean 自动设置宽高
        iconUrl: "", // string 头像地址
        activeNum: 0, // number 当前勾选的checkbox个数
        // modal
        modalData: [], // Array: [object]
        canResetmodalData: true, //第一次进来，要先获取setOrgShapeCardData
        expandList: ["shape", "option", "size", "layout"],
        oldTableList: null, // 操作前的双列显示排序
        layout: 0, //number 当前形状layout(layoutMenu btn index) 从item._layout(eConLyt)获取做映射
        topLayout: 0, //number 根节点layout(layoutMenu btn index)
        isInGroup: false, //bool   是否在组合内
        isGroupTop: false, //bool   是否为orgGroupShape top
        canGroup: true, //bool   能否可以进行组合
        cardStyleApplyOption: "Selected", //卡片样式应用范围
        cardApplyOption: "Selected",
        applyStr: "", //initDragOrgchart 传参判断字段
    },
    mutations: {
        setOrgchartState(state, obj) {
            state[obj.type] = obj.data;
        },

        initOrgchart(state, object) {
            state.btnType = -1;
            if (object) {
                state.showPhoto = object.showPhoto;
                if (state.showPhoto) state.photoDirect = object.photoDirect.toString();
                else state.photoDirect = "-1";

                state.keepShapeSize = object.keepShapeSize;
                state.textVertical = object.textVertical;
                state.textWrap = object.textWrap;
                state.canAddColleague = object.canAddColleague;
                state.width = object.width;
                state.height = object.height;
                state.vertical = object.vertical;
                state.horizontal = object.horizontal;
                state.orgVerDistance = object.orgVerDistance;
                state.orgHorDistance = object.orgHorDistance;
                state.itemList = object.itemList;
                state.tableList = object.tableList;
                state.iconUrl = object.imageUrl;
                state.double = false;
                state.leftData = [];
                state.rightData = [];
                state.layout = object.layout;
                state.topLayout = object.topLayout;
                state.isInGroup = object.isInGroup;
                state.isGroupTop = object.isGroupTop;
                state.canGroup = object.canGroup;
                //state.applyOption = object.applyOption;
                state.activeNum = object.itemList.reduce((a, b) => {
                    b.show && (a++, true);
                    return a;
                }, 0);
            }
            this.commit("initOrgchartTableList");
        },

        initOrgchartTableList(state) {
            if (state.showPhoto) {
                if (state.photoDirect == "1" || state.photoDirect == "3") {
                    // 头像在上下
                    state.btnType = state.photoDirect == "1" ? 2 : 3;
                    if (state.tableList[0] && state.tableList[0].isShort) {
                        //双列
                        state.double = true;

                        this.commit("updateDouble");

                        let lArr = [],
                            rArr = [];
                        for (let i = 0; i < state.tableList.length; i++) {
                            let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                            temp.id = i;
                            if (i % 2 == 0 || state.tableList[i].isShort == false) {
                                lArr.push(temp);
                            } else {
                                rArr.push(temp);
                            }
                        }
                        state.leftData = lArr;
                        state.rightData = rArr;
                    } else {
                        //单列
                        state.double = false;
                        state.leftData = JSON.parse(JSON.stringify(state.tableList));
                    }
                } else if (state.photoDirect == "0") {
                    // 左
                    state.btnType = 1;
                    state.double = false;
                    state.rightData = JSON.parse(JSON.stringify(state.tableList));
                } else if (state.photoDirect == "2") {
                    // 右
                    state.btnType = 4;
                    state.double = false;
                    state.leftData = JSON.parse(JSON.stringify(state.tableList));
                }
            } else {
                // 没有头像
                state.btnType = 0;
                if (state.tableList[0] && state.tableList[0].isShort) {
                    //双列
                    state.double = true;

                    this.commit("updateDouble");

                    let lArr = [],
                        rArr = [];
                    for (let i = 0; i < state.tableList.length; i++) {
                        let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                        temp.id = i;
                        if (i % 2 == 0 || state.tableList[i].isShort == false) {
                            lArr.push(temp);
                        } else {
                            rArr.push(temp);
                        }
                    }
                    state.leftData = lArr;
                    state.rightData = rArr;
                } else {
                    //单列
                    state.double = false;
                    state.leftData = JSON.parse(JSON.stringify(state.tableList));
                }
            }
        },
        getOrgchartItem(state, type) {
            let obj = window["_view"]._orgUITool.orgDispData();
            switch (type) {
                case "icon": {
                    state.iconUrl = obj.imageUrl;
                    break;
                }
                case "tableList": {
                    state.tableList = obj?.tableList || [];
                    if (state.tableList.length == 0) {
                        state.leftData = [];
                        state.rightData = [];
                    } else {
                        this.commit("initOrgchartTableList");
                    }
                    break;
                }
                case "itemList": {
                    state.itemList = obj.itemList;
                    break;
                }
            }
        },

        initDragOrgchart(state, obj) {
            state.oldTableList = state.tableList;
            state.applyStr = obj.applyStr;

            /**
             * 合并leftData && rightData (一左一右)
             * @param flag true: 合并到rightData false: 合并到leftData
             */
            let handleData = (flag) => {
                let newData = [];

                let i = 0;
                let j = 0;

                while (i < state.leftData.length || j < state.rightData.length) {
                    if (i < state.leftData.length) {
                        newData.push(state.leftData[i]);
                        i++;
                    }

                    if (j < state.rightData.length) {
                        newData.push(state.rightData[j]);
                        j++;
                    }
                }

                if (flag) {
                    state.rightData = newData;
                    state.leftData = [];
                } else {
                    state.rightData = [];
                    state.leftData = newData;
                }
            };

            switch (obj.type) {
                case "text": {
                    state.hasPhotoShowInMul = false;
                    state.hasPhotoHideInMul = true;
                    state.showPhoto = false;
                    state.photoDirect = "-1";
                    state.iconUrl = "";
                    if (state.double) {
                        let lArr = [],
                            rArr = [];
                        for (let i = 0; i < state.tableList.length; i++) {
                            let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                            temp.id = i;
                            if (i % 2 == 0 || state.tableList[i].isShort == false) {
                                lArr.push(temp);
                            } else {
                                rArr.push(temp);
                            }
                        }
                        state.leftData = lArr;
                        state.rightData = rArr;
                    } else {
                        // state.leftData = state.leftData.concat(state.rightData)
                        // state.rightData = [];

                        handleData(false);

                        state.leftData = state.leftData.map((v, k) => {
                            v.isShort = false;
                            return v;
                        });
                    }
                    break;
                }
                case "top": {
                    state.hasPhotoShowInMul = true;
                    state.hasPhotoHideInMul = false;
                    state.showPhoto = true;
                    state.photoDirect = "1";
                    this.commit("dragOrgchartReset");
                    this.commit("getOrgchartItem", "icon");
                    if (state.double) {
                        let lArr = [],
                            rArr = [];
                        for (let i = 0; i < state.tableList.length; i++) {
                            let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                            temp.id = i;
                            if (i == state.tableList.length - 1) {
                                temp.isShort = false;
                            }
                            if (i % 2 == 0) {
                                lArr.push(temp);
                            } else {
                                rArr.push(temp);
                            }
                        }
                        state.leftData = lArr;
                        state.rightData = rArr;
                    } else {
                        // state.leftData = state.leftData.concat(state.rightData)
                        // state.rightData = [];
                        handleData(false);
                    }
                    break;
                }
                case "right": {
                    state.hasPhotoShowInMul = true;
                    state.hasPhotoHideInMul = false;
                    state.showPhoto = true;
                    state.photoDirect = "2";
                    this.commit("dragOrgchartReset");
                    this.commit("getOrgchartItem", "icon");
                    state.double = false;
                    // state.leftData = state.leftData.concat(state.rightData)
                    // state.rightData = [];

                    handleData(false);

                    break;
                }
                case "bottom": {
                    state.hasPhotoShowInMul = true;
                    state.hasPhotoHideInMul = false;
                    state.showPhoto = true;
                    state.photoDirect = "3";
                    this.commit("dragOrgchartReset");
                    this.commit("getOrgchartItem", "icon");
                    if (state.double) {
                        let lArr = [],
                            rArr = [];
                        for (let i = 0; i < state.tableList.length; i++) {
                            let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                            temp.id = i;
                            if (i == state.tableList.length - 1) {
                                temp.isShort = false;
                            }
                            if (i % 2 == 0) {
                                lArr.push(temp);
                            } else {
                                rArr.push(temp);
                            }
                        }
                        state.leftData = lArr;
                        state.rightData = rArr;
                    } else {
                        // state.leftData = state.leftData.concat(state.rightData)
                        // state.rightData = [];

                        handleData(false);
                    }
                    break;
                }
                case "left": {
                    state.hasPhotoShowInMul = true;
                    state.hasPhotoHideInMul = false;
                    state.showPhoto = true;
                    state.photoDirect = "0";
                    this.commit("dragOrgchartReset");
                    this.commit("getOrgchartItem", "icon");
                    state.double = false;
                    // state.rightData = state.rightData.concat(state.leftData)
                    // state.leftData = [];

                    handleData(true);

                    break;
                }
                case "double": {
                    state.hasPhotoShowInMul = true;
                    state.hasPhotoHideInMul = false;
                    this.commit("dragOrgchartReset");
                    if (state.double) {
                        let lArr = [],
                            rArr = [];
                        for (let i = 0; i < state.tableList.length; i++) {
                            let temp = JSON.parse(JSON.stringify(state.tableList[i]));
                            temp.id = i;
                            if (i == state.tableList.length - 1) {
                                temp.isShort = false;
                            }
                            if (i % 2 == 0) {
                                lArr.push(temp);
                            } else {
                                rArr.push(temp);
                            }
                        }
                        state.leftData = lArr;
                        state.rightData = rArr;
                    } else {
                        // state.leftData = state.leftData.concat(state.rightData)
                        // state.rightData = [];
                        handleData(false);
                    }
                    state.oldTableList = null;
                }
            }
            if (obj.undo) {
                state.oldTableList = null;
                this.commit("dragOrgchartOver", true);
            } else this.commit("dragOrgchartOver");
        },
        dragOrgchart(state, obj) {
            this.commit("dragOrgchartReset");
            switch (obj.type) {
                case "left-to-left": {
                    // 左盒子上下交换
                    let temparr = state.leftData.splice(obj.dragID, 1)[0];
                    state.leftData.splice(obj.dragToID, 0, temparr);
                    break;
                }
                case "left-to-right": {
                    // 左盒子移动到右盒子

                    if (state.textVertical && obj.dragID == state.leftData.length - 1) {
                        return;
                    }

                    state.rightData.length == 0 && ((state.double = true), true); // 拖动前右盒子为空，拖动后设置为双列
                    let temparr = state.leftData.splice(obj.dragID, 1)[0];
                    state.rightData.splice(state.rightData.length, 0, temparr);
                    state.leftData.length == 0 && ((state.double = false), true); // 拖动后左盒子为空，拖动后设置为单列
                    break;
                }
                case "right-to-right": {
                    // 右盒子上下交换
                    let temparr = state.rightData.splice(obj.dragID, 1)[0];
                    state.rightData.splice(obj.dragToID, 0, temparr);
                    break;
                }
                case "right-to-left": {
                    // 右盒子移动到左盒子
                    state.leftData.length == 0 && ((state.double = true), true); // 拖动前左盒子为空，拖动后设置为双列
                    let temparr = state.rightData.splice(obj.dragID, 1)[0];
                    state.leftData.splice(state.leftData.length, 0, temparr);
                    state.rightData.length == 0 && ((state.double = false), true); // 拖动后右盒子为空，拖动后设置为单列
                    break;
                }
                // case 'all-left':{       // 所有数据转移到左盒子
                //     state.double = false;
                //     state.leftData = state.leftData.concat(state.rightData)
                //     state.rightData = [];
                //     break
                // }
                // case 'all-right':{      // 所有数据转移到右盒子
                //     state.double = false;
                //     state.rightData = state.rightData.concat(state.leftData)
                //     state.leftData = [];
                //     break
                // }
            }
            this.commit("dragOrgchartOver");
        },
        dragOrgchartReset(state) {
            state.leftData = state.leftData.map((v, k) => {
                v.isShort = true;
                return v;
            });
            state.rightData = state.rightData.map((v, k) => {
                v.isShort = true;
                return v;
            });
        },
        dragOrgchartOver(state, isUndo: boolean = false) {
            // 拖动完成，组合数据并提交

            let itemTable = state.tableList;

            let leftLength = state.leftData.length;
            let rightLength = state.rightData.length;
            this.commit("dragOrgchartReset");
            if (leftLength > rightLength && rightLength !== 0) {
                // 左数据大于右数据
                let arr = [];
                if (leftLength - rightLength == 1) {
                    for (let i = 0; i < rightLength; i++) {
                        state.leftData[i].isShort = true;
                        state.rightData[i].isShort = true;
                        arr.push(state.leftData[i]);
                        arr.push(state.rightData[i]);
                    }
                    let last = state.leftData[leftLength - 1];
                    last.isShort = false;
                    arr.push(last);
                    // if(!state.double){
                    //     arr = arr.map((v, k) => {
                    //         v.isShort = false;
                    //         return v
                    //     })
                    // }
                } else {
                    for (let i = 0; i < rightLength; i++) {
                        state.leftData[i].isShort = true;
                        state.rightData[i].isShort = true;
                        arr.push(state.leftData[i]);
                        arr.push(state.rightData[i]);
                    }
                    let tempArr = JSON.parse(JSON.stringify(state.leftData));
                    tempArr = tempArr.splice(rightLength, tempArr.length - 1);
                    tempArr.map((v, k) => {
                        v.isShort = false;
                        return v;
                    });
                    arr = arr.concat(tempArr);
                }
                state.tableList = arr;
            } else if (rightLength > leftLength && leftLength !== 0) {
                // 右数据大于左数据
                let arr = [];
                if (rightLength - leftLength == 1) {
                    for (let i = 0; i < leftLength; i++) {
                        state.leftData[i].isShort = true;
                        state.rightData[i].isShort = true;
                        arr.push(state.leftData[i]);
                        arr.push(state.rightData[i]);
                    }
                    let last = state.rightData[rightLength - 1];
                    last.isShort = false;
                    arr.push(last);
                    if (!state.double) {
                        arr = arr.map((v, k) => {
                            v.isShort = false;
                            return v;
                        });
                    }
                } else {
                    for (let i = 0; i < leftLength; i++) {
                        state.leftData[i].isShort = true;
                        state.rightData[i].isShort = true;
                        arr.push(state.leftData[i]);
                        arr.push(state.rightData[i]);
                    }
                    let tempArr = JSON.parse(JSON.stringify(state.rightData));
                    tempArr = tempArr.splice(leftLength, tempArr.length - 1);
                    tempArr.map((v, k) => {
                        v.isShort = false;
                        return v;
                    });
                    arr = arr.concat(tempArr);
                }
                state.tableList = arr;
            } else if (leftLength === 0) {
                // 只有右侧数据
                if ((state.showPhoto && state.double) || state.photoDirect == "0" || state.photoDirect == "2") {
                    // 有头像且显示双列
                    state.tableList = state.rightData;
                } else {
                    state.tableList = state.rightData.map((v, k) => {
                        v.isShort = false;
                        return v;
                    });
                }
            } else if (rightLength === 0) {
                // 只有左侧数据
                if ((state.showPhoto && state.double) || state.photoDirect == "0" || state.photoDirect == "2") {
                    // 有头像且显示双列
                    state.tableList = state.leftData;
                } else {
                    state.tableList = state.leftData.map((v, k) => {
                        v.isShort = false;
                        return v;
                    });
                }
            } else {
                // 两组数据长度相同
                let arr = [];
                for (let i = 0; i < leftLength; i++) {
                    state.leftData[i].isShort = true;
                    state.rightData[i].isShort = true;
                    arr.push(state.leftData[i]);
                    arr.push(state.rightData[i]);
                }
                state.tableList = arr;
            }

            this.commit("updateDouble");

            if (state.textVertical) {
                for (let i = 0; i < state.tableList.length; i++) {
                    state.tableList[i].isShort = false;
                }
            }

            if (!isUndo) window["_view"]._orgUITool.orgApplyLayoutDisp("layout", state, 0, state.applyStr);

            state.oldTableList = null;
        },
        // modal
        setOrgchartModal(state, obj) {
            switch (obj.type) {
                case "reset": {
                    state.modalData = obj.data;
                    break;
                }
                case "all": {
                    window["_view"]._orgUITool.orgApplyFields(state.modalData);
                    this.commit("getOrgchartItem", "itemList");
                    break;
                }
                case "checkbox": {
                    let temp = state.modalData[obj.index];
                    temp.check = !temp.check;
                    state.modalData.splice(obj.index, 1, temp);
                    break;
                }
                case "type": {
                    let temp = state.modalData[obj.index];
                    temp.type = obj.data;
                    state.modalData.splice(obj.index, 1, temp);
                    break;
                }
                case "format": {
                    let temp = state.modalData[obj.index];
                    temp.format = obj.data;
                    state.modalData.splice(obj.index, 1, temp);
                    break;
                }
                case "formula": {
                    let temp = state.modalData[obj.index];
                    temp.formula = obj.data;
                    state.modalData.splice(obj.index, 1, temp);
                    break;
                }
            }
        },
        toggleOrgchartImportModal(state) {
            state.showImportModal = !state.showImportModal;
        },
        setapplyOption(state, data) {
            state.applyOption = data;
        },
        setCardStyleApplyOption(state, data) {
            state.cardStyleApplyOption = data;
        },
        setCardApplyOption(state, data) {
            state.cardApplyOption = data;
        },
        updateDouble(state) {
            for (let i = 0; i < state.tableList.length - 1; i++) {
                if (!state.tableList[i].isShort) {
                    state.double = false;
                    break;
                }
            }
        },
    },
};
